
import React, { useEffect, useState } from 'react'
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'
import { Box, Flex, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import Button from '../Components/Button'
import { GetAllPendingStock, GetAllProduct, ScheduleStock, StoreSupervisor } from '../Utils/ApiCalls'
import StockRow from '../Components/StockRow'
import Preloader from '../Components/Preloader'
import CreateReturnToShelf from '../Components/CreateReturnToShelf'
import { showToast } from '../Utils/tool'
import ColorCode from '../Components/ColorCode'

export default function PendingFinancialStock() {

    const [Shelf, setShelf] = useState();
    const [Data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [Loading, setLoading] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [SingleData, setSingleData] = useState();


    const takeStokeApi = async () => {

        try {
            setisLoading(true)
            let result = await GetAllPendingStock(Shelf)
            console.log("object all pending product", result);

            if (result.status === true) {
                setisLoading(false)
                setData(result.queryresult)

            } else {
                setisLoading(false)

            }
        } catch (e) {
            setisLoading(false)

        }
    }


    const [Response, setResponse] = useState({
        approvalresponse: false,
        data: ""
    });

    const Reject =  async (id) => {

      
        try {

            setResponse({
                approvalresponse: false,
                data: [{ _id: id }]
            })
      
            setLoading(true)
            let result = await StoreSupervisor(Response)
            console.log(" Reject product", result);
            
            if (result.status === true) {
                setLoading(false)
                takeStokeApi()

                showToast({
                    type:'success',
                    message: " Stock has been Rejected Successfully "
                })

            } else {
               setLoading(false)

            }
        } catch (e) {
           setLoading(false)

        }

    }
    const Approve = async (id) => {

      
        try {

            setResponse({
                approvalresponse: true,
                data: [{ _id: id }]
            })
    
            setLoading(true)
            let result = await StoreSupervisor(Response)
            console.log("Approve product", result);
            
            if (result.status === true) {
                setLoading(false)
                takeStokeApi()
                showToast({
                    type:'success',
                    message: "Stock has been approved Successfully "
                })

            } else {
               setLoading(false)

            }
        } catch (e) {
           setLoading(false)

        }


    }
    const ApproveAll = async () => {
        let arr = []

        Data.map((item,i)=>(
            arr.push({"_id": item._id})
        ))

        setResponse({
            approvalresponse: true,
            data: arr
        })
      
        try {
            setLoading(true)
            let result = await StoreSupervisor(Response)
            console.log("ApproveAll pending product", result);
            
            if (result.status === true) {
                setLoading(false)
                 takeStokeApi()
                showToast({
                    type:'success',
                    message: "All Stock is has been approved Successfully "
                })

            } else {
               setLoading(false)

            }
        } catch (e) {
           setLoading(false)

        }



    }

    // console.log("Response", Response)

    useEffect(() => {
        takeStokeApi()
    }, [isOpen, Loading]);

    return (
        <MainLayout>
            <Seo title='Take Stock' description='IMS Take Stock' />
            <Box rounded="8px" bg="#ddd" px="1%" py="10px">
            {
                Loading && (
                    <Preloader/>
                )
            }
                <Flex flexWrap={"wrap"} justifyContent={"space-between"}>
                    <Box w={["100%", "100%", "100%", "45%", "45%",]}>
                        <Text fontWeight={"500"} pb="5px"> Type of Store</Text>
                        <Select borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Shelf != "" ? "16px" : "12px"} id='store' value={Shelf} onChange={(e) => setShelf(e.target.value)}>

                            <option value="1" >Admin Store Marina</option>
                            <option value="2" >Central Circle stores, Ijora</option>
                            <option value="3" >East Circle stores, Island</option>
                            <option value="4" >West Circle stores, Festac</option>

                        </Select>

                    </Box>
                    <Flex w={["100%", "100%", "100%", "45%", "45%",]} position={"relative"} bottom={"-7"} >

                        <Button  onClick={takeStokeApi} disabled={Shelf !== "" ? false : true} isLoading={isLoading}>Get Pending Stock</Button>
                    </Flex>

                </Flex>

                {/* <Button mt={"20px"} isLoading={Loading} disabled={Report.typeof !== "" && Report.fromDate !== "" && Report.toDate !== "" && Report.store !== "" ? false : true} onClick={GetReport}>Get Report</Button> */}
            </Box>



            <Box display={"block"} pos="relative" alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

            <ColorCode />

                    <Table variant='simple' size='sm' overflowX="auto" color={"#fff"}>
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Product name</Th>
                                <Th color="#fff">CountedGroupQty</Th>
                                <Th color="#fff">ShelfGroupQty</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Approve</Th>



                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                Data?.map((item, i) => (
                                    <StockRow
                                        type={"pendingStock"}
                                        sn={i + 1}
                                        productName={item.productname}
                                        qty={item.countedqty}
                                        serviceable={item.countedqtyserviceable}
                                        unServiceable={item.countedqtyunserviceable}
                                        shelfQty={item.shelfid?.qty}
                                        shelfServiceable={item.shelfid?.qtyserviceable}
                                        shelfUnServiceable={item.shelfid?.qtyunserviceable}
                                        store={Shelf}
                                        index={item}
                                        TakeData={Data}
                                        approve={() => Approve(item._id)}
                                        reject={() => Reject(item._id)}
                                    />
                                ))
                            }
                        </Tbody>

                    </Table>
           

                {
                    Data.length > 0 && (

                        <Box pos={"absolute"} w={"100%"} bottom={"0"} cursor="pointer" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={ApproveAll}>Approve All</Box>
                    )
                }


            </Box>


        </MainLayout>
    )
}
